import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchMenuData, fetchMenuDataSuccess } from "../redux/action";

export default function useAvailabilityRefresh(restaurantId) {
  const dispatch = useDispatch();
  const menu = useSelector(state => state.user.menu);
  useEffect(() => {
    const times = (menu?.categories || []).flatMap(category => category.items || [])
      .map(item => Date.parse(item.availabilityValidUntil)).filter(Number.isFinite);
    if (!restaurantId || !times.length) return;
    const next = Math.min(...times);
    let retry;
    const refresh = () => {
      dispatch(fetchMenuData(restaurantId));
    };
    const timeout = setTimeout(() => {
      // Close stale ordering controls while the boundary refresh is in flight.
      const now = Date.now();
      if ((menu.categories || []).some(c => c.items?.some(i => i.canOrder && Date.parse(i.availabilityValidUntil) <= now))) {
        dispatch(fetchMenuDataSuccess({ ...menu, categories: menu.categories.map(c => ({ ...c,
          items: c.items.map(i => Date.parse(i.availabilityValidUntil) <= now ? { ...i, canOrder: false, availabilityMessage: "Checking availability…" } : i)
        })) }));
      }
      refresh();
      retry = setInterval(refresh, 30000);
    }, Math.max(1000, Math.min(next - Date.now() + 100, 2147483647)));
    const resume = () => { if (document.visibilityState === "visible" && Date.now() >= next) refresh(); };
    document.addEventListener("visibilitychange", resume);
    return () => { clearTimeout(timeout); clearInterval(retry); document.removeEventListener("visibilitychange", resume); };
  }, [restaurantId, menu, dispatch]);
}
